import styled from '@emotion/styled';

import ArrowDownIcon from '@/assets/svg/ui-elements/arrow-down.svg';
import ArrowUpIcon from '@/assets/svg/ui-elements/arrow-up.svg';
import { Button, Typography } from '@/design-system';
import { theme } from '@/design-system/theme';

const SectionHeader = styled('div', {
  shouldForwardProp: (prop) => prop !== '$mobile',
})<{ $mobile?: boolean }>(({ theme: t, $mobile }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: t.spacing[16],
  ...($mobile && { marginBottom: t.spacing[16] }),
}));

const HeaderActions = styled('div', {
  shouldForwardProp: (prop) => prop !== '$mobile',
})<{ $mobile?: boolean }>(({ theme: t, $mobile }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: t.spacing[8],

  ...($mobile && {
    width: '100%',
    '& > button': { flex: 1, minHeight: theme.spacing[40] },
  }),
}));

type CryptoAssetsActionsProps = {
  isMobile: boolean;
  canSend: boolean;
  canReceive: boolean;
  onSend: () => void;
  onReceive: () => void;
};

export const CryptoAssetsActions = ({
  isMobile,
  canSend,
  canReceive,
  onSend,
  onReceive,
}: CryptoAssetsActionsProps) => (
  <SectionHeader $mobile={isMobile}>
    <Typography as={isMobile ? 'h3' : undefined} variant="h5" color={theme.colors.text.primary}>
      Crypto Assets
    </Typography>
    <HeaderActions $mobile={isMobile}>
      <Button size="md" variant="subtle" color="primary" onClick={onSend} disabled={!canSend}>
        <ArrowUpIcon /> Send
      </Button>
      <Button size="md" variant="subtle" color="primary" onClick={onReceive} disabled={!canReceive}>
        <ArrowDownIcon /> Receive
      </Button>
    </HeaderActions>
  </SectionHeader>
);
